
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 122.88 121.83"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M102.42 37h-20.5a8.52 8.52 0 01-8.85-8.7V7.53H21a.58.58 0 00-.41.18.45.45 0 00-.18.42v105.58a.7.7 0 00.18.41.51.51 0 00.41.18h80.84c.18 0 .17-.09.26-.18s.34-.28.34-.41V37zm7.47 79.08a5.77 5.77 0 01-5.76 5.76H18.66a5.77 5.77 0 01-5.76-5.76V5.76a5.7 5.7 0 011.69-4.07A5.77 5.77 0 0118.66 0H76.9a4.22 4.22 0 012.46.82l29.75 30.12a2.57 2.57 0 01.78 2.6v82.53zM80 27.69l-.43-18.06L100.66 31l-18.14-.81a2.4 2.4 0 01-2.52-2.5z","fill-rule":"evenodd"}}),_c('path',{attrs:{"d":"M6.71 46.28h109.46a6.73 6.73 0 016.71 6.72v45.1a6.73 6.73 0 01-6.71 6.71H6.71A6.73 6.73 0 010 98.09V53a6.73 6.73 0 016.71-6.71z","fill":"red","fill-rule":"evenodd"}}),_c('path',{attrs:{"d":"M16.33 59.78h16.2c3.53 0 6.17.83 7.94 2.51s2.63 4.08 2.63 7.18a9.71 9.71 0 01-2.88 7.47c-1.91 1.8-4.84 2.69-8.77 2.69H26.1V91.3h-9.77V59.78zm9.77 13.47h2.4a6.22 6.22 0 004-1 3.17 3.17 0 001.14-2.51 3.51 3.51 0 00-1-2.52c-.66-.69-1.91-1-3.75-1H26.1v7zm22.2-13.47h14.48a17.47 17.47 0 016.92 1.16 11.23 11.23 0 014.35 3.33 13.66 13.66 0 012.49 5 23.36 23.36 0 01.78 6.11 21.16 21.16 0 01-1.15 7.84A13 13 0 0173 87.93a10.38 10.38 0 01-4.39 2.51 22.39 22.39 0 01-5.81.86H48.3V59.78zm9.7 7.13v17.22h2.4a10.16 10.16 0 004.36-.68 4.65 4.65 0 002-2.36 14.84 14.84 0 00.73-5.48q0-5-1.63-6.85c-1.09-1.23-2.91-1.85-5.44-1.85zm24.43-7.13h24.09v6.78H92.24v5.5h12.24v6.39H92.24V91.3h-9.78V59.78z","fill":"#fff"}})])
          )
        }
      }
    